(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cfbl-community-magazine"] && !Shopify.designMode) return;
  try {
    
(function(){
  function pad(n){return String(n).padStart(2,'0')}
  function init(root){
    var book=root.querySelector('[data-cm-book]');if(!book||book.dataset.cmReady)return;book.dataset.cmReady='1';
    var spreads=[].slice.call(book.querySelectorAll(':scope > .cm-spread')),i=0,busy=false,
        prev=root.querySelector('[data-cm-prev]'),next=root.querySelector('[data-cm-next]'),count=root.querySelector('[data-cm-count]');
    function show(){spreads.forEach(function(s,k){s.classList.toggle('is-on',k===i);s.setAttribute('aria-hidden',k===i?'false':'true')});
      if(count)count.textContent=pad(i+1)+' / '+pad(spreads.length);
      if(prev)prev.disabled=i===0;if(next)next.disabled=i===spreads.length-1}
    function face(page,cls){var f=document.createElement('div');f.className='cm-face '+cls;
      var s=page.parentNode.cloneNode(false);s.classList.remove('is-on');s.removeAttribute('aria-label');s.appendChild(page.cloneNode(true));f.appendChild(s);return f}
    function go(j){i=j;show()}
    function turn(dir){
      if(busy)return;var j=i+dir;if(j<0||j>=spreads.length)return;
      var wide=window.matchMedia('(min-width:990px)').matches,reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      if(!wide||reduce){go(j);if(!wide)root.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});return}
      busy=true;var cur=spreads[i],nxt=spreads[j],fwd=dir>0,flip=document.createElement('div');flip.className='cm-flip';
      var front=cur.querySelector(fwd?'.cm-page--r':'.cm-page--l'),back=nxt.querySelector(fwd?'.cm-page--l':'.cm-page--r');
      flip.style[fwd?'right':'left']='0';flip.style.transformOrigin=fwd?'left center':'right center';
      flip.appendChild(face(front,'cm-face--front'));flip.appendChild(face(back,'cm-face--back'));
      nxt.classList.add('is-on');back.style.visibility='hidden';front.style.visibility='hidden';
      cur.style.zIndex=2;nxt.style.zIndex=1;book.appendChild(flip);
      requestAnimationFrame(function(){requestAnimationFrame(function(){flip.style.transform='rotateY('+(fwd?-180:180)+'deg)'})});
      var done=function(){[cur,nxt].forEach(function(s){s.style.zIndex='';[].forEach.call(s.querySelectorAll('.cm-page'),function(p){p.style.visibility=''})});
        flip.remove();busy=false;go(j)};
      var t=setTimeout(done,1100);flip.addEventListener('transitionend',function(e){if(e.target!==flip)return;clearTimeout(t);done()},{once:true});
    }
    if(prev)prev.addEventListener('click',function(){turn(-1)});
    if(next)next.addEventListener('click',function(){turn(1)});
    root.addEventListener('keydown',function(e){if(e.target.closest('a,input,textarea'))return;if(e.key==='ArrowRight')turn(1);if(e.key==='ArrowLeft')turn(-1)});
    var x0=null;book.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
    book.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>50)turn(dx<0?1:-1);x0=null});
    root._cmGo=function(k){if(k>=0&&k<spreads.length)go(k)};
    show();
  }
  function all(){document.querySelectorAll('.cm').forEach(init)}
  if(document.readyState!=='loading')all();else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.cm');if(r)init(r)});
  document.addEventListener('shopify:block:select',function(e){var s=e.target.closest&&e.target.closest('.cm-spread');if(!s)return;
    var r=s.closest('.cm');var list=[].slice.call(r.querySelectorAll('[data-cm-book] > .cm-spread'));if(r._cmGo)r._cmGo(list.indexOf(s))});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cfbl-team-row"] && !Shopify.designMode) return;
  try {
    
(function () {
  var GAP = 28;
  function update(section) {
    if (!section) return;
    var track = section.querySelector('[data-cfbl-team-track]');
    if (!track) return;
    var over = track.scrollWidth > track.clientWidth + 4;
    section.classList.toggle('is-overflowing', over);
    var prev = section.querySelector('[data-cfbl-team-dir="-1"]');
    var next = section.querySelector('[data-cfbl-team-dir="1"]');
    if (prev) prev.disabled = track.scrollLeft <= 4;
    if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
  }
  function all() {
    document.querySelectorAll('.cfbl-team--scroll').forEach(update);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-cfbl-team-dir]') : null;
    if (!btn) return;
    var section = btn.closest('.cfbl-team');
    var track = section && section.querySelector('[data-cfbl-team-track]');
    if (!track) return;
    var card = track.querySelector('.cfbl-team__card');
    var step = card ? card.getBoundingClientRect().width + GAP : track.clientWidth * 0.8;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: step * Number(btn.getAttribute('data-cfbl-team-dir')), behavior: reduce ? 'auto' : 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-cfbl-team-track]')) update(t.closest('.cfbl-team'));
  }, true);
  window.addEventListener('resize', all);
  window.addEventListener('load', all);
  document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', all);
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (el && el.classList && el.classList.contains('cfbl-team__card')) {
      el.scrollIntoView({ block: 'nearest', inline: 'start' });
    }
  });
  all();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cfbl-video-qa"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-vqa-play]') : null;
    if (!btn) return;
    var screen = btn.closest('.cfbl-vqa__screen');
    var video = screen && screen.querySelector('video');
    if (!video) return;
    document.querySelectorAll('.cfbl-vqa__video').forEach(function (v) { if (v !== video) v.pause(); });
    screen.classList.add('is-playing');
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
    video.focus();
  });
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!v.classList || !v.classList.contains('cfbl-vqa__video')) return;
    var s = v.closest('.cfbl-vqa__screen'); if (s) s.classList.add('is-playing');
    document.querySelectorAll('.cfbl-vqa__video').forEach(function (o) { if (o !== v) o.pause(); });
  }, true);
})();

  } catch(e) { console.error(e); }
})();
})();
